var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"special-btn",class:[_vm.type.replace(' ', '-')]},[_c('q-btn',_vm._g(_vm._b({class:{ active: _vm.active },attrs:{"unelevated":"","no-caps":""}},'q-btn',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }